let token = '';
const initialState = token;
export default (state = initialState, action = {}) => {
    if (action.type === 'USER_LOGGED_IN') {
        token = action.payload;
        return token;
    }
    return state;
}